<template>
  <div class="image-preview">
    <Spinner v-if="isLoadingFile" />
    <img v-else class="image-preview__image" :src="fileURL" :alt="fileName">
    <slot />
  </div>
</template>

<script>
import { mixinFile } from '@/mixins/files/mixinFile'

export default {
  name: 'ImagePreview',
  mixins: [mixinFile],
  async mounted () {
    await this.ensureLoaded()
  }
}
</script>
